@import '~less/global-variables';
@import '~less/bootstrap/legacy-mixins';

.profile-remove {
  scroll-margin-top: calc(var(--tr-header-height, @navbar-height) + 15px);
}

// Make space for .profile-edit-navbar-mobile
.profile-edit {
  margin-bottom: @navbar-height;

  @media (max-width: @screen-xs-max) {
    margin-bottom: 80px;
  }
}

.profile-edit-navbar-mobile .navbar-nav {
  flex-direction: row;
  width: 100%;

  > li {
    flex: 1;
    text-align: center;
  }
}

.profile-newsletter label {
  display: inline-flex;
  align-items: center;
  gap: 8px;

  input[type='checkbox'] {
    margin: 0;
  }
}

.profile-remove-confirmation label {
  display: inline-flex;
  align-items: center;
  gap: 6px;

  input[type='checkbox'] {
    margin: 0;
  }
}

// Profile edit navbar, visible only on bigger screens
.profile-edit-navbar > li > a {
  color: @text-color;
  padding: 12px 15px;
  line-height: 22px;
}

.profile-edit-navbar > li + li {
  margin-top: 4px;
}

.profile-edit-description.medium-editor-element {
  &,
  &:focus {
    min-height: 150px;
    margin-bottom: 10px;
    font-size: 15px;
    line-height: 22px;
    border-bottom: 1px solid @gray-lighter;
  }
  &:focus {
    border-color: lighten(@brand-primary, 50%);
  }
}

.profile-edit-description-progress {
  width: 100px;
  margin: 8px 0 0 10px;
  height: 6px;
  .progress-bar {
    background-color: lighten(@gray, 50%);
    box-shadow: none;
  }
}

// Profile avatar
.profile-photo-picker:focus-within {
  outline: 3px solid @brand-primary;
  outline-offset: 3px;
}

.profile-edit-avatar-choise {
  border-bottom: 1px solid @gray-lighter;
  padding-bottom: 25px;
  margin-bottom: 10px;

  @media (max-width: @screen-sm-max) {
    text-align: center;
  }
  @media (min-width: @screen-md-min) {
    // For our flexbox helper to work, all these need to be the same height as the avatar
    .flex-centered {
      min-height: 128px;
    }
  }
}
@media (min-width: @screen-md-min) {
  .profile-edit-avatar-label {
    .flex-centered {
      justify-content: flex-start;
    }
  }
}

.profile-avatar-choises .profile-edit-avatar-choise:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.profile-edit-avatar-sources {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 20px;
  margin-top: 12px;

  @media (max-width: @screen-sm-max) {
    justify-content: center;
  }

  .radio {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin: 0;
    padding: 0;
  }

  .radio input[type='radio'] {
    margin: 0;
  }
}

// When avatar image works as a link
.avatar-source-link {
  display: block;
  position: relative;
  .square(128px);
  @media (max-width: @screen-sm-max) {
    margin-left: auto;
    margin-right: auto;
  }
  img {
    position: absolute;
    top: 0;
    left: 0;
  }
  span {
    position: absolute;
    display: block;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    line-height: 128px;
    text-align: center;
    color: #fff;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    transition: background 0.2s;
    background: transparent;
    font-weight: bold;
  }
  &:hover,
  &:active {
    span {
      background: rgba(0, 0, 0, 0.1);
    }
  }
}
.avatar-source-label {
  margin: 10px 0 15px 0;
  input {
    margin-right: 5px;
  }
}
.avatar-source-upload {
  cursor: pointer;
}
.avatar-source-preview {
  .square(128px);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-color: transparent;
  @media (max-width: @screen-sm-max) {
    margin-left: auto;
    margin-right: auto;
  }
}

.profile-edit-avatar-drop {
  display: block;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: (
    @zindex-modal + 100
  ); // `@zindex-modal` is the highest from Bootstrap
  border: 10px solid transparent;
  text-align: center;
  visibility: hidden;
  &.visibleDrop {
    visibility: visible;
  }
  .drop-instructions {
    opacity: 0;
    pointer-events: none;
    .drop-instructions-accept,
    .drop-instructions-reject {
      display: none;
    }
    opacity: 1;
    cursor: pointer;
  }
  &.acceptDrop {
    border-color: @filedrop-accepted;
    background-color: lighten(@filedrop-accepted, 40%);
    .drop-instructions-accept {
      display: block;
    }
  }
  &.rejectDrop {
    border-color: @filedrop-rejected;
    background-color: lighten(@filedrop-rejected, 40%);
    .drop-instructions-reject {
      display: block;
      cursor: not-allowed;
      cursor: no-drop;
    }
  }
  &.rejectDrop,
  &.acceptDrop {
    user-select: none;
    opacity: 1;
    .drop-instructions {
      opacity: 1;
    }
  }
}

// Usernamefields for external hospex sites (WS+BW+CS)
.extsites {
  // Help button and the service URL
  .input-group-addon {
    background: @input-bg;
    padding-left: 5px;
    padding-right: 5px;
  }
  // Consists the service URL
  label.input-group-addon {
    border-left: 0;
    border-right: 0;
    color: @input-color;
    padding-left: 0;
    @media (min-width: @screen-sm-min) {
      padding-right: 0;
    }
  }
  // Username input
  input {
    border-left-color: transparent;
    padding-left: 2px;
    border-left: 0;
    box-shadow: none;
    font-weight: 500;
    &:focus {
      border-color: @input-border;
      box-shadow: none;
      color: @input-color;
    }
  }
  .has-warning input:focus {
    box-shadow: none;
  }
}

.legacy-social-connections {
  margin-top: 30px;
  max-width: 520px;

  > ul {
    border: 1px solid @gray-lighter;
    border-radius: @border-radius-base;
    margin-bottom: 0;
  }

  > ul > li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    min-height: 52px;
    padding: 8px 10px;

    & + li {
      border-top: 1px solid @gray-lighter;
    }
  }

  .legacy-social-provider {
    align-items: center;
    display: flex;
    font-size: 16px;
    gap: 7px;

    small {
      background: @gray-lighter;
      border-radius: 10px;
      color: @gray;
      font-size: 9px;
      font-weight: 600;
      letter-spacing: 0.04em;
      line-height: 16px;
      padding: 0 6px;
      text-transform: uppercase;
    }
  }
}

.nostr-nip07-suggestion {
  code {
    display: block;
    max-width: 100%;
    overflow-wrap: anywhere;
    white-space: normal;
    word-break: break-word;
  }

  .btn {
    margin-top: 5px;
  }
}
